import { FormControlLabel, RadioGroup, Typography, Box, Radio } from "@mui/material";
import { Colors } from "../../../helpers/Consts";
import { ICompositionGroupList } from "../../../types/Product";
import logger from "../../../components/Logger";

type OpcoesDeQuantidadeDeSaboresProps = {
  category: ICompositionGroupList | undefined,
  onSelecionaQuantidadeDeSabor: (categoryId: number, quantidade: number) => void,
  seTelaEditarQuantosSaboresJaSelecionados: number | undefined
}
//onSelecionaQuantidadeDeSabor
/**
 * Obs: se a categoria não controla sabores, retorna um fragment vazio
 *
 * Monta o radio group que permite o usuário escolher a quantidade de sabores para uma category que controla sabores
 * exemplo:
 * ( ) 1 Sabor
 * ( ) 2 Sabores
 * ( ) 3 Sabores
 * etc...
 * @param category
 * @param onSelecionaQuantidadeDeSabor
 * @param seTelaEditarQuantosSaboresJaSelecionados
 */
export default function OpcoesDeQuantidadeDeSabores ({category, onSelecionaQuantidadeDeSabor, seTelaEditarQuantosSaboresJaSelecionados}: OpcoesDeQuantidadeDeSaboresProps) {
  if(!category) return (<></>)

  if(!category.flavour_control ) return (<></>)

  logger.log('seTelaEditarQuantosSaboresJaSelecionados', seTelaEditarQuantosSaboresJaSelecionados)

  // se controla sabores, a quantidade mínima é 1: inteiro
  const opcoes = ['1 Sabor']
  for(let i = 2; i <= category.max; i++){
    opcoes.push(`${i} Sabores`)
  }

  return (
      <>
        <Box
          sx={{
            border: '1px solid #DEDEDE',
            padding: '5px',
            backgroundColor: '#DEDEDE',
            display: "flex",
          }}
        >
          <Typography
            sx={{
              fontSize: "12px",
              backgroundColor: '#DEDEDE',
              display: "flex",
            }}>
            Escolha a quantidade de sabores:
          </Typography>
        </Box>
        <RadioGroup>
          {opcoes.map((o, index) =>
            <Box
              sx={{
                display: "flex",
                backgroundColor: index % 2 === 0 ? 'none' : "#f9f4f4",
              }}
              key={index}
            >
              <FormControlLabel
                sx={{marginLeft:'8px'}}
                control={(<Radio size={'small'}
                                 value={index + 1}
                                 checked={seTelaEditarQuantosSaboresJaSelecionados === undefined
                                   ? undefined
                                   : index + 1 === seTelaEditarQuantosSaboresJaSelecionados
                                    ? true
                                     : undefined }
                                 onChange={() => onSelecionaQuantidadeDeSabor(category.id, index+1)} />)}
                label={
                  <Typography  fontSize="12px" color={Colors.baseTextColor}>
                    {o}
                  </Typography>
                } />
            </Box>
          )}
        </RadioGroup>
      </>
    )
}